module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_1_m.43c9a36914435bb42dacdabb72651901.png";